/** Métadonnées SEO / partage social — site public JCONSULT MY Academia. */
export const SITE_METADATA = {
  siteName: 'JCONSULT MY Academia',
  defaultTitle: 'JCONSULT MY Academia',
  defaultDescription:
    'Centre de formation professionnelle certifiante à Kinshasa — inscriptions en ligne, filières professionnelles, suivi apprenant et certification.',
  keywords:
    'JCONSULT, formation professionnelle, Kinshasa, RDC, certification, inscription en ligne, centre de formation, apprenant, filières',
  author: 'JCONSULT MY SARL',
  locale: 'fr_CD',
  themeColor: '#872320',
  twitterCard: 'summary_large_image',
  defaultOgType: 'website',
  supportEmail: 'academia@jconsultmy.com',
} as const;

export function formatPageTitle(pageTitle?: string): string {
  if (!pageTitle?.trim()) return SITE_METADATA.defaultTitle;
  return `${pageTitle.trim()} | ${SITE_METADATA.siteName}`;
}

/** Origine publique du site (canonical, Open Graph). */
export function getSiteOrigin(): string {
  const fromEnv = (process.env.REACT_APP_PUBLIC_SITE_URL || '').trim().replace(/\/$/, '');
  if (fromEnv) return fromEnv;
  if (typeof window !== 'undefined') return window.location.origin;
  return 'https://academia.jconsult.cd';
}

export function getDefaultOgImage(): string {
  const publicPath = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
  return `${getSiteOrigin()}${publicPath}/logo512.png`;
}

export function buildCanonicalUrl(pathname = '/'): string {
  const path = pathname.startsWith('/') ? pathname : `/${pathname}`;
  return `${getSiteOrigin()}${path}`;
}
